import {globals, globalUser} from "../modules/globals.js";
import {getChampionshipPrestigeIconHtml, getPointsHtml, hideContent, runFuseElementsSearch} from "./ui-helpers.js";
import {playSoundEffect} from "./sounds.js";
import {
    addOrEditBrand,
    getAddBrandSelections,
    getBrandDraftSelectionsData,
    getViewBrandsData, removeBrand,
    runBrandDraft,
    saveYearlyBrandDraftSettings
} from "../modules/brands.js";
import {getCompanySelectData} from "../modules/companies.js";
import {addCompaniesDataToSelectElement} from "./roster-sub-menu.js";
import {commaSeparate} from "../modules/helpers.js";
import {updateEventCardBrand} from "./event-card.js";
import {showDraftPage} from "./drafts.js";

async function loadViewBrandsPage(companyUid) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get view brands data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let viewBrandsData = await getViewBrandsData(companyUid);

    // Get company select data (if loading first time)
    let companySelectData;
    if (!companyUid) {
        companySelectData = await getCompanySelectData();
    }
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show company select
    if (!companyUid) {
        addCompaniesDataToSelectElement(companySelectData, $('.view-brands-company-select'));
    }
    // Show view brands data
    hideContent($());
    showViewBrandsPageData(viewBrandsData);
}

function showViewBrandsPageData(data) {
    const $viewBrandsItemsContainer = $(".view-brands-items-container");
    const $viewBrandsContainer = $('#view-brands-container');
    $viewBrandsItemsContainer.html('');

    // Show brands
    data.forEach(function (brand) {
        let viewBrandHtml = getViewBrandHtml(brand);
        $viewBrandsItemsContainer.append(viewBrandHtml);
    });

    // Show empty text if no brands
    if (data.length === 0) {
        let div =
            '<div class="view-brands-item disabled">' +
                '<div>' +
                    '<span class="grey">No Brands present</span>' +
                '</div>' +
            '</div>';
        $('.view-brands-items-container').append(div);
    }

    $viewBrandsContainer.fadeIn('slow');
    $viewBrandsItemsContainer.scrollTop(0);

    // Brand click handler
    $viewBrandsContainer.off('click', '.view-brands-item');
    $viewBrandsContainer.on('click', '.view-brands-item', function () {
        if ($(this).hasClass('disabled')) {
            return false;
        }
        let brandUid = parseInt($(this).attr('data-uid'));
        let brandData = data.filter(function (obj) {
            return obj.uid === brandUid;
        })[0];
        let isCompetitorBrand = $('.view-brands-company-select').find(":selected[data-is-competitor]").length > 0;
        showViewBrandDetailsPage(brandData, isCompetitorBrand);
    });

    // Edit brand
    const $brandDetailsContainer = $('.brand-details-container');
    $brandDetailsContainer.off('click', '.edit-brand-menu-button');
    $brandDetailsContainer.on('click', '.edit-brand-menu-button', async function () {
        let brandUid = $brandDetailsContainer.data('brandUid');
        let brandData = data.filter(function (obj) {
            return obj.uid === brandUid;
        })[0];
        await loadAddBrandPage(brandData);
    });
}

function getViewBrandHtml(brand) {
    // Get number of brand objects
    let brandSuperstarsWord = (brand['superstars'].length === 1) ? 'Superstar' : 'Superstars';
    let brandSuperstarsHtml = '{0} {1}'.format(brand['superstars'].length, brandSuperstarsWord);
    let brandChampionshipsWord = (brand['championships'].length === 1) ? 'Championship' : 'Championships';
    let brandChampionshipsHtml = '{0} {1}'.format(brand['championships'].length, brandChampionshipsWord);
    let brandEventsWord = (brand['events'].length === 1) ? 'Event' : 'Events';
    let brandEventsHtml = '{0} {1}'.format(brand['events'].length, brandEventsWord);
    let brandNumberOfObjects = [brandSuperstarsHtml, brandChampionshipsHtml, brandEventsHtml].join(', ');

    // Get brand color
    let brandNameStyleHtml = '';
    if (brand['color'] && !globalUser.settings.colorblindMode) {
        brandNameStyleHtml = ' style="color: ' + brand['color'] + '"';
    }

    // Get hot or stale
    let brandHotOrStaleHtml = '';
    if (brand['hot']) {
        brandHotOrStaleHtml = '<img alt="Hot" src="static/www/static/hot_icon.png" class="fire-image margin-left-5"/>'
    } else if (brand['stale']) {
        brandHotOrStaleHtml = '<img alt="Stale" src="static/www/static/stale_icon.png" class="fire-image margin-left-5"/>'
    }

    // Get brand overness
    let brandOvernessHtml = '<span class="margin-right-6 grey help-text" ' +
        'title="Brand Overness affects Event Hype for the brand\'s exclusive events.">Ovr.</span>' +
        brand['overness'] + '%';

    // Get html
    return '<div class="view-brands-item" data-uid="' + brand['uid'] + '">' +
        '<div class="margin-bottom-8">' +
        '<span' + brandNameStyleHtml + '>' + brand['name'] + brandHotOrStaleHtml + '</span>' +
        '<span class="float-right grey">' +
        brandOvernessHtml +
        '</span>' +
        '</div>' +
        '<div class="grey">' +
        brandNumberOfObjects +
        '</div>' +
        '</div>';
}

function showViewBrandDetailsPage(data, isCompetitorBrand) {

    let $brandDetailsContainer = $('.brand-details-container');

    // Name
    $brandDetailsContainer.find('.brand-details-name').html(data['name']);

    // Set color if present
    if (data['color'] && !globalUser.settings.colorblindMode) {
        $brandDetailsContainer.find('.brand-details-name').css('color', data['color'])
    }
    else {
        $brandDetailsContainer.find('.brand-details-name').css('color', '')
    }

    // Weekly show name, exclusive
    $brandDetailsContainer.find('.brand-details-weekly-show-name').html(data['weeklyShowName']);
    $brandDetailsContainer.find('.brand-details-weekly-show-is-exclusive').html((data['weeklyShowIsExclusive']) ? 'Yes' : 'No');

    // Overness, hot or stale
    let brandHotOrStaleHtml = '';
    if (data['hot']) {
        brandHotOrStaleHtml = '<img alt="Hot" src="static/www/static/hot_icon.png" class="fire-image margin-left-5"/>'
    }
    else if (data['stale']) {
        brandHotOrStaleHtml = '<img alt="Stale" src="static/www/static/stale_icon.png" class="fire-image margin-left-5"/>'
    }
    let brandOvernessHtml = data['overness'] + '%' + brandHotOrStaleHtml;
    $brandDetailsContainer.find('.brand-details-overness').html(brandOvernessHtml);

    // Superstars
    let brandSuperstarsHtml = '';
    data['superstars'].forEach(function (superstar) {
        brandSuperstarsHtml += '<div class="margin-bottom-6">' + superstar['name'] + '</div>'
    });
    if (data['superstars'].length <= 0) {
        brandSuperstarsHtml += '<div class="margin-bottom-6">None</div>'
    }
    $brandDetailsContainer.find('.brand-details-superstars').html(brandSuperstarsHtml);

    // Championships
    let brandChampionshipsHtml = '';
    data['championships'].forEach(function (championship) {
        // Get name and prestige icon
        let championshipPrestigeIcon = '<span class="margin-left-6">' +
            getChampionshipPrestigeIconHtml(championship['prestige']) +
            '</span>';
        brandChampionshipsHtml += '<div class="margin-bottom-6">' + championship['name'] +
            championshipPrestigeIcon + '</div>'
    });
    if (data['championships'].length <= 0) {
        brandChampionshipsHtml += '<div class="margin-bottom-6">None</div>'
    }
    $brandDetailsContainer.find('.brand-details-championships').html(brandChampionshipsHtml);

    // Events
    let brandEventsHtml = '';
    data['events'].forEach(function (event) {
        // Get name and prestige icon
        let eventPrestigeIcon = '<span class="margin-left-6">' +
            getChampionshipPrestigeIconHtml(event['prestige']) +
            '</span>';
        brandEventsHtml += '<div class="margin-bottom-6">' + event['name'] + eventPrestigeIcon + '</div>'
    });
    if (data['events'].length <= 0) {
        brandEventsHtml += '<div class="margin-bottom-6">None</div>'
    }
    $brandDetailsContainer.find('.brand-details-events').html(brandEventsHtml);

    // Show all buttons
    $brandDetailsContainer.find('.brand-details-buttons').children().show();

    // Hide all buttons except 'back' if competitor brand
    if (isCompetitorBrand) {
        $brandDetailsContainer.find('.brand-details-buttons').children(':not(.back-to-view-brands-button)').hide();
    }

    // Add uid to data
    $brandDetailsContainer.data('brandUid', data['uid']);

    // Show brand details container
    hideContent($());
    $brandDetailsContainer.fadeIn('slow');
    $brandDetailsContainer[0].scrollIntoView();
    $brandDetailsContainer.find('.brand-details-superstars').scrollTop(0);
    $brandDetailsContainer.find('.brand-details-inside-container').scrollTop(0);
}

function loadEditBrandDetails(data) {
    let parent = $(".add-brand-container");

    // Set header
    parent.find('.add-brand-header').text('Edit Brand');
    parent.find('.add-brand-cost').text('50');
    parent.find('.add-brand-help-content').text('Changing your Brand\'s name or weekly show name will lower its ' +
        'Overness slightly.');
    parent.find('.add-brand-help').show();

    // Set inputs
    parent.find('.add-brand-name').val(data['name']);
    parent.find('.add-brand-weekly-show-name').val(data['weeklyShowName']);
    if (data['weeklyShowIsExclusive']) {
        parent.find('input[value="weekly_show_is_exclusive"]').prop('checked', true);
    }
    else {
        parent.find('input[value="weekly_show_is_exclusive"]').prop('checked', false);
    }

    // Set color, preview
    parent.find('.add-brand-preview').text(data['name']);
    parent.find('.add-brand-preview').css('color', data['color']);
    parent.find('.add-brand-color').val(data['color']);
    parent.find('.add-brand-color').spectrum('set', data['color']);

    // Select brand objects
    parent.find('.brand-selection-item[data-brand-name="' + data['name'].replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1') + '"]').addClass('selected');

    // Update superstars selected
    let brandSuperstarsSelected = parent.find('.add-brand-selection-superstars .brand-selection-item.selected');
    let selectedNames = Array.from(brandSuperstarsSelected, function(el) {
        return $(el).find('.brand-selection-item-name').text()
    });
    let superstarsSelected = (selectedNames.length > 0) ? commaSeparate(selectedNames) : '';
    parent.find('.add-brand-selection-superstars-selected').text(superstarsSelected);

    // Set buttons
    parent.find('.edit-brand-button, .back-to-brand-details-button').show();
    parent.find('.add-brand-button, .back-to-view-brands-button').hide();
}

async function getAddOrEditBrandRequest(edit = false) {

    if (globals.requestRunning) {
        return;
    }

    let parent = $('.add-brand-container');

    // Get brand attributes
    let brandName = parent.find('.add-brand-name').val();
    let brandWeeklyShowName = parent.find('.add-brand-weekly-show-name').val();
    let weeklyShowIsExclusive = parent.find('input[value="weekly_show_is_exclusive"]').prop('checked');
    let brandColor = parent.find('.add-brand-color').val();
    let brandUid = $('.brand-details-container').data('brandUid');  // For editing brand

    // Get superstars/events/championships selected
    let superstarUids = Array.from(parent.find('.add-brand-selection-superstars .brand-selection-item.selected'), function (x) {
        return parseInt($(x).attr('data-uid'));
    });
    let eventUids = Array.from(parent.find('.add-brand-selection-events .brand-selection-item.selected'), function (x) {
        return parseInt($(x).attr('data-uid'));
    });
    let championshipUids = Array.from(parent.find('.add-brand-selection-championships .brand-selection-item.selected'), function (x) {
        return parseInt($(x).attr('data-uid'));
    });

    // Validate
    if (brandName.length <= 0) {
        notie.alert({type: 3, text: "Enter a name for the Brand"});
        return false;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await addOrEditBrand(brandName, brandWeeklyShowName, weeklyShowIsExclusive, brandColor, superstarUids,
        eventUids, championshipUids, edit, brandUid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showAddOrEditBrandData(data, edit);
}

function showAddOrEditBrandData(data, edit) {
    if (!data['error']) {
        playSoundEffect('success');

        let brandWord = (edit) ? 'edited' : 'added';
        let html = '<span class="display-block">' +
            data['brandName'] + " Brand " + brandWord +
            '</span>';

        notie.alert({type: 4, text: html, stay: true});

        // Update points
        let pointsHtml = getPointsHtml(data['points'], globals.game.unlimitedCreativePoints);
        $(".points-number").html(pointsHtml);

        // Show brand name
        updateEventCardBrand(data['currentEvent']);

        // Go back to view brands
        setTimeout(function () {
            $('#view-brands-menu-button').trigger('click');
        }, 800);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'not-enough-points') {
            let brandWord = (edit) ? 'edit' : 'add';
            notie.alert({type: 3, text: "You do not have enough Creative Points to " + brandWord + " a brand."});
        }
        if (data['error'] === 'not-paid') {
            notie.alert({type: 3, text: "Brands are only available in JoW Paid."});
        }
        if (data['error'] === 'brand-name-exists') {
            notie.alert({type: 3, text: "A brand with that name already exists."});
        }
        if (data['error'] === 'weekly-show-name-exists') {
            notie.alert({type: 3, text: "A weekly show with that name already exists."});
        }
        if (data['error'] === 'brand-not-found') {
            notie.alert({type: 3, text: "The selected brand could not be found. Please try again."});
        }
        if (data['error'] === 'max-brands') {
            notie.alert({type: 3, text: "You cannot have more than 3 brands."});
        }
        if (data['error'] === 'mars') {
            notie.alert({type: 3, text: "You cannot add Brands in Wrestling on Mars"});
        }
        if (data['error'] === 'passion') {
            notie.alert({type: 3, text: "You cannot add Brands in Passion of Wrestling"});
        }
    }
}

async function getRemoveBrandRequest(brandUid) {

    if (globals.requestRunning) {
        return;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await removeBrand(brandUid);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showRemoveBrandData(data);
}

function showRemoveBrandData(data) {
    if (!data['error']) {
        playSoundEffect('success');
        let html = '<span class="display-block">' +
            data['brandName'] + " Brand removed" +
            '</span>';

        notie.alert({type: 4, text: html, stay: true});

        // Show brand name
        updateEventCardBrand(data['currentEvent']);

        // Go back to view brands
        setTimeout(function () {
            $('#view-brands-menu-button').trigger('click');
        }, 800);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'brand-not-found') {
            notie.alert({type: 3, text: 'That brand could not be found. Please try again.'});
        }
        else if (data['error'] === 'at-weekly-show') {
            notie.alert({type: 3, text: 'Brands can only be removed at a monthly event. This is to avoid conflicts with the current weekly show.'});
        }
    }
}

function runAddBrandSuperstarsSearch() {

    let addBrand = $('.add-brand-container');
    let availableSuperstarsContainer = addBrand.find('.add-brand-selection-superstars');
    let availableSuperstarsElements = availableSuperstarsContainer.find('.brand-selection-item');
    let searchTerm = addBrand.find(".add-brand-superstar-search-input").val();

    availableSuperstarsElements.hide();

    // Run search
    if (searchTerm.length > 0) {
        let searchResults = runFuseElementsSearch(availableSuperstarsElements, searchTerm, ['textContent']);
        // Show results if found
        if (searchResults.length > 0) {
            searchResults.forEach(function (e) {
                $(e).show()
            });
            $('.no-add-brand-superstar-search-results').hide();
        }
        else {
            const $noSearchResults = $('.no-add-brand-superstar-search-results');
            if ($noSearchResults.length > 0) {
                $noSearchResults.show()
            }
            else {
                availableSuperstarsContainer.append('<div class="no-add-brand-superstar-search-results inner-box-item ' +
                    'disabled empty light-grey">No Results Found</div>')
            }
        }
    }
    else {
        availableSuperstarsElements.show();
    }

    availableSuperstarsContainer.scrollTop(0);
}

async function loadAddBrandPage(brandData) {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getAddBrandSelections();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showAddBrandPageData(data, brandData);
}

function showAddBrandPageData(data, brandData) {
    let parent = $('.add-brand-container');
    let addedBrands = $("#view-brands-container").find('.view-brands-item:not(.disabled)').length;
    const $addBrandSelectionSuperstars = $('.add-brand-selection-superstars');
    const $addBrandSelectionChampionships = $('.add-brand-selection-championships');
    const $addBrandSelectionEvents = $('.add-brand-selection-events');

    // Show no cost for first brand
    let cost = (addedBrands > 0) ? '100' : '0';

    // Reset header, inputs, buttons
    parent.find('.add-brand-header').text('Add Brand');
    parent.find('.add-brand-cost').text(cost);
    parent.find('.add-brand-help').hide();
    parent.find('.add-brand-name, .add-brand-weekly-show-name, .add-brand-color').val('');
    parent.find('input[value="weekly_show_is_exclusive"]').prop('checked', true);
    parent.find('.add-brand-preview').text('Preview');
    parent.find('.add-brand-preview').css('color', '');
    parent.find('.edit-brand-button, .back-to-brand-details-button').hide();
    parent.find('.add-brand-button, .back-to-view-brands-button').show();

    // Superstars
    let superstarsHtml = '';
    data['superstars'].forEach(function (superstar) {
        superstarsHtml += getBrandSuperstarsSelectionHtml(superstar)
    });
    $addBrandSelectionSuperstars.html(superstarsHtml);

    // Championships
    let championshipsHtml = '';
    data['championships'].forEach(function (championship) {
        championshipsHtml += getBrandChampionshipsSelectionHtml(championship)
    });
    $addBrandSelectionChampionships.html(championshipsHtml);

    // Events
    let eventsHtml = '';
    data['events'].forEach(function (event, eventIndex) {
        eventsHtml += getBrandEventsSelectionHtml(event, eventIndex)
    });
    $addBrandSelectionEvents.html(eventsHtml);

    // Add color select
    parent.find(".add-brand-color").spectrum({
        preferredFormat: "hex",
        allowEmpty: true,
        showInitial: true,
        showInput: true,
        showButtons: false
    });

    parent.fadeIn('slow').removeClass('display-none');

    // Reset selections scroll, selected text, search
    $addBrandSelectionSuperstars.scrollTop(0);
    $('.add-brand-selection-superstars-selected').text('');
    $addBrandSelectionChampionships.scrollTop(0);
    $addBrandSelectionEvents.scrollTop(0);
    $('.add-brand-superstar-search-input').val('');

    if (brandData) {
        loadEditBrandDetails(brandData)
    }
}

function getBrandSuperstarsSelectionHtml(superstar) {

    let popularity = '<span class="margin-left-10">' +
                     '<i class="fa fa-angle-double-up margin-right-5"></i>' + superstar['popularity'] + '</span>';
    let age = '<span class="margin-left-10 light-grey">' + superstar['age'] + ' y/o</span>';
    let appearances = (superstar['appearances'] != null) ? '<span class="light-grey">' + superstar['appearances'] + ' apps.</span>' : '';

    // Superstar name, color and help text
    let superstarNameClass = '';
    let superstarHelpTexts = [];
    if (superstar['appearances'] != null) {
        superstarNameClass = 'blue';
        superstarHelpTexts.push('Part-timer')
    }
    if (superstar['championshipNames'].length > 0) {
        superstarNameClass = 'gold';
        let championships = Array.from(superstar['championshipNames'], function(championship) {return championship + ' Champion'});
        superstarHelpTexts.push(commaSeparate(championships));
    }
    if (superstar['injured']) {
        superstarNameClass = 'dark-red';
        superstarHelpTexts.push('Injured for {0} months'.format(superstar['injured']));
    }
    if (superstar['retired']) {
        superstarNameClass = 'medium-light-grey';
        superstarHelpTexts.push('Retired');
    }
    if (superstar['fullTimeManager']) {
        superstarNameClass = 'manager-color';
        superstarHelpTexts.push('Full-time Manager');
    }

    let superstarName;
    if (superstarHelpTexts.length > 0) {
        superstarName = '<div class="line-height-1p4 brand-selection-item-name ' + superstarNameClass +
            ' help-text display-inline-block margin-right-8" title="' + superstarHelpTexts.join(', ') + '">' + superstar['name']  + '</div>'
    }
    else if (superstarNameClass) {
        superstarName = '<div class="line-height-1p4 brand-selection-item-name display-inline-block margin-right-8' +
            superstarNameClass + '">' + superstar['name']  + '</div>'
    }
    else {
        superstarName = '<div class="line-height-1p4 brand-selection-item-name display-inline-block margin-right-8">' +
            superstar['name'] + '</div>'
    }

    let brandNameHtml = '';
    let dataBrandName = '';
    if (superstar['brandName']) {
        let brandNameStyleHtml = '';
        if (superstar['brandColor'] && !globalUser.settings.colorblindMode) {
            brandNameStyleHtml = ' style="color: ' + superstar['brandColor'] + '"';
        }
        brandNameHtml = '<span class="font-14px light-grey display-inline-block margin-top-2"' + brandNameStyleHtml + '>' +
            superstar['brandName'] + '</span>';
        // Use data-brand-name to select brand objects while editing
        dataBrandName = '" data-brand-name="' + superstar['brandName'].replace(/"/g, "&quot;");
    }

    return '<div class="inner-box-item brand-selection-item" data-uid="' + superstar['uid'] + dataBrandName + '">' +
            '<div class="medium-dark-grey">' +
                '<div class="brand-selection-item-column-left">' +
                    superstarName + brandNameHtml +
                '</div>' +
                '<div class="brand-selection-item-column-right">' +
                    '<span>' +
                    appearances + age + popularity +
                    '</span>' +
                '</div>' +
                '<div class="clear"></div>' +
            '</div>' +
        '</div>';
}

function getBrandChampionshipsSelectionHtml(championship) {

    let brandNameHtml = '';
    let dataBrandName = '';
    if (championship['brandName']) {
        let brandNameStyleHtml = '';
        if (championship['brandColor'] && !globalUser.settings.colorblindMode) {
            brandNameStyleHtml = ' style="color: ' + championship['brandColor'] + '"';
        }
        brandNameHtml = '<span class="font-14px light-grey display-inline-block margin-top-2"' + brandNameStyleHtml + '>' +
            championship['brandName'] + '</span>';
        dataBrandName = '" data-brand-name="' + championship['brandName'].replace(/"/g, "&quot;");
    }

    // Get name and prestige icon
    let championshipPrestigeIcon = '<span class="margin-left-6">' +
        getChampionshipPrestigeIconHtml(championship['prestige']) +
        '</span>';
    let championshipName = '<div class="brand-selection-item-name line-height-1p4 display-inline-block margin-right-8">' +
        championship['name'] + championshipPrestigeIcon + '</div>';

    // Get rank
    let rank = '<span class="margin-left-10 light-grey">' + championship['rank'] + '</span>';

    return '<div class="inner-box-item brand-selection-item" data-uid="' + championship['uid'] + dataBrandName + '">' +
            '<div class="medium-dark-grey">' +
                '<div class="brand-selection-item-column-left">' +
                    championshipName + brandNameHtml +
                '</div>' +
                '<div class="brand-selection-item-column-right">' +
                    rank +
                '</div>' +
                '<div class="clear"></div>' +
            '</div>' +
        '</div>';
}

function getBrandEventsSelectionHtml(event, eventIndex) {
    let months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    let brandNameHtml = '';
    let dataBrandName = '';
    if (event['brandName']) {
        let brandNameStyleHtml = '';
        if (event['brandColor'] && !globalUser.settings.colorblindMode) {
            brandNameStyleHtml = ' style="color: ' + event['brandColor'] + '"';
        }
        brandNameHtml = '<span class="font-14px light-grey display-inline-block margin-top-2"' + brandNameStyleHtml + '>' +
            event['brandName'] + '</span>';
        dataBrandName = '" data-brand-name="' + event['brandName'].replace(/"/g, "&quot;");
    }

    // Get name and prestige icon
    let eventPrestigeIcon = '<span class="margin-left-6">' +
        getChampionshipPrestigeIconHtml(event['prestige']) +
        '</span>';
    let eventName = '<div class="brand-selection-item-name line-height-1p4 display-inline-block margin-right-8">' +
        event['name'] + eventPrestigeIcon + '</div>';

    // Get month
    let eventMonth = '<span class="light-grey">' + months[eventIndex] + '</span>';

    return '<div class="inner-box-item brand-selection-item" data-uid="' + event['uid'] + dataBrandName + '">' +
        '<div class="medium-dark-grey">' +
        '<div class="brand-selection-item-column-left">' +
        eventName + brandNameHtml +
        '</div>' +
        '<div class="brand-selection-item-column-right">' +
        eventMonth +
        '</div>' +
        '<div class="clear"></div>' +
        '</div>' +
        '</div>';
}

async function getRunBrandDraftRequest() {

    if (globals.requestRunning) {
        return;
    }

    let parent = $('.run-brand-draft-container');
    let brandDraftSettings = {};
    brandDraftSettings.type = parent.find('input[type="radio"][name="run-brand-draft-type-option"]:checked').val();
    brandDraftSettings.brandUids = Array.from(parent.find('.run-brand-draft-selection-brands .brand-selection-item.selected'), function (x) {
        return parseInt($(x).attr('data-uid'));
    });

    // Validate brand selections
    if (brandDraftSettings.brandUids.length < 1) {
        notie.alert({type: 3, text: "You need to select at least one Brand to hold a draft"});
        return false;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await runBrandDraft(brandDraftSettings);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    showRunBrandDraftData(data);
}

function showRunBrandDraftData(data) {
    if (!data['error']) {
        playSoundEffect('success');
        showDraftPage(data['draftData']);
    }
    else {
        playSoundEffect('error');
        if (data['error'] === 'brand-not-found') {
            notie.alert({type: 3, text: "One of the selected brands could not be found. Please try again."});
        }
        if (data['error'] === 'not-enough-points') {
            notie.alert({type: 3, text: "You do not have enough Creative Points to run a draft."});
        }
        if (data['error'] === 'no-brands-present') {
            notie.alert({type: 3, text: "You need to select at least one Brand to hold a draft."});
        }
        if (data['error'] === 'not-paid') {
            notie.alert({type: 3, text: "Brands are only available in JoW Paid."});
        }
    }
}

async function getSaveYearlyBrandDraftSettingsRequest() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    let parent = $('.yearly-brand-draft-container');
    let yearlyBrandDraftSettings = {};
    yearlyBrandDraftSettings.run = parent.find('input[value="run_yearly_draft"]').prop('checked');
    yearlyBrandDraftSettings.type = parent.find('input[type="radio"][name="yearly-brand-draft-type-option"]:checked').val();
    yearlyBrandDraftSettings.month = parent.find('select[name="yearly-brand-draft-month-option"]').val();
    yearlyBrandDraftSettings.brandUids = Array.from(parent.find('.yearly-brand-draft-selection-brands .brand-selection-item.selected'), function (x) {
        return parseInt($(x).attr('data-uid'));
    });

    // Validate brand selections
    if (yearlyBrandDraftSettings.run && yearlyBrandDraftSettings.brandUids.length < 1) {
        notie.alert({type: 3, text: "You need to select at least one Brand to hold a draft"});
        return false;
    }

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    await saveYearlyBrandDraftSettings(yearlyBrandDraftSettings);
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    notie.alert({type: 4, text: 'Yearly Draft settings updated'});
    $('#view-brands-container').fadeIn('slow');
}

async function loadRunBrandDraftPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getBrandDraftSelectionsData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showRunBrandDraftPageData(data);
}

function showRunBrandDraftPageData(data) {
    if (data['brands'].length > 0) {
        playSoundEffect('success');
        let parent = $('.run-brand-draft-container');

        // Reset cost, input
        parent.find('.run-brand-draft-cost').text('100');
        parent.find('input[type="radio"][name="run-brand-draft-type-option"][value="shuffle"]').prop('checked', true).trigger('click');

        // Add brands
        let brandsHtml = '';
        data['brands'].forEach(function (brand) {
            brandsHtml += getBrandDraftBrandsSelection(brand)
        });
        parent.find('.run-brand-draft-selection-brands').html(brandsHtml);

        parent.fadeIn('slow').removeClass('display-none');
    }
    else {
        playSoundEffect('error');
        notie.alert({type: 3, text: 'You need to have at least one Brand present to hold a draft.'});
    }
}

async function loadYearlyBrandDraftPage() {

    if (globals.requestRunning) {
        return;
    }

    playSoundEffect('success');

    // Get data
    notie.alert({type: 4, text: '<i class="fa fa-spinner fa-spin margin-right-5"></i>Loading', stay: true});
    globals.requestRunning = true;
    let data = await getBrandDraftSelectionsData();
    globals.requestRunning = false;
    notie.hideAlerts();

    // Show data
    hideContent($());
    showYearlyBrandDraftPageData(data);
}

function showYearlyBrandDraftPageData(data) {
    if (data['brands'].length > 0) {
        playSoundEffect('success');
        let parent = $('.yearly-brand-draft-container');

        // Add brands
        let brandsHtml = '';
        data['brands'].forEach(function (brand) {
            brandsHtml += getBrandDraftBrandsSelection(brand)
        });
        parent.find('.yearly-brand-draft-selection-brands').html(brandsHtml);

        let yearlyDraftSettings = data['yearlyBrandDraftSettings'];
        if (yearlyDraftSettings && yearlyDraftSettings['run']) {
            // Load yearly brand draft settings if present
            parent.find('input[value="run_yearly_draft"]').prop('checked', true);
            parent.find('input[type="radio"][name="yearly-brand-draft-type-option"][value="' + yearlyDraftSettings['type'] + '"]').prop('checked', true).trigger('click');
            parent.find('select[name="yearly-brand-draft-month-option"]').val(yearlyDraftSettings['month']);
            parent.find('.yearly-brand-draft-selection-brands .brand-selection-item').each(function (i, e) {
                if (yearlyDraftSettings['brandUids'].indexOf(parseInt($(e).attr('data-uid'))) >= 0) {
                    $(e).addClass('selected')
                } else {
                    $(e).removeClass('selected')
                }
            });
            parent.find('.yearly-brand-draft-options-container').show();
        }
        else {
            // Otherwise reset inputs
            parent.find('input[type="radio"][name="yearly-brand-draft-type-option"][value="shuffle"]').prop('checked', true).trigger('click');
            parent.find('select[name="yearly-brand-draft-month-option"]').val('0');
            parent.find('input[value="run_yearly_draft"]').prop('checked', false);
            parent.find('.yearly-brand-draft-options-container').hide();
        }

        parent.fadeIn('slow').removeClass('display-none');
    }
    else {
        playSoundEffect('error');
        notie.alert({type: 3, text: 'You need to have at least one Brand present to hold a draft.'});
    }
}

function getBrandDraftBrandsSelection(brand) {
    // Get brand color
    let brandNameStyleHtml = '';
    if (brand['color'] && !globalUser.settings.colorblindMode) {
        brandNameStyleHtml = ' style="color: ' + brand['color'] + '"';
    }

    return '<div class="inner-box-item brand-selection-item selected" data-uid="' + brand['uid'] + '">' +
            '<div class="medium-dark-grey">' +
                '<div' + brandNameStyleHtml + '>' +
                    brand['name'] +
                '</div>' +
            '</div>' +
        '</div>';
}

export {getViewBrandHtml, showViewBrandDetailsPage}

export {loadViewBrandsPage, loadRunBrandDraftPage, loadYearlyBrandDraftPage, loadAddBrandPage,
    loadEditBrandDetails, getSaveYearlyBrandDraftSettingsRequest, getRunBrandDraftRequest,
    getRemoveBrandRequest, getAddOrEditBrandRequest, runAddBrandSuperstarsSearch}